import { render, staticRenderFns } from "./TaskW2s.vue?vue&type=template&id=58ec8aae&scoped=true"
import script from "./TaskW2s.vue?vue&type=script&lang=js"
export * from "./TaskW2s.vue?vue&type=script&lang=js"
import style0 from "./TaskW2s.vue?vue&type=style&index=0&id=58ec8aae&scoped=scss&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ec8aae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58ec8aae')) {
      api.createRecord('58ec8aae', component.options)
    } else {
      api.reload('58ec8aae', component.options)
    }
    module.hot.accept("./TaskW2s.vue?vue&type=template&id=58ec8aae&scoped=true", function () {
      api.rerender('58ec8aae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Task/TaskElement/TaskW2s.vue"
export default component.exports